import axios from 'axios';

import type {
  ContactListSortOrder,
  IContactSearchRequest,
  IContactSearchResponse,
  ListContactType,
} from '@bb/contacts';

const searchContacts = async (
  input: string,
  activeList: ListContactType,
  startIndex: number,
  limit: number,
  sort?: {
    field: string;
    order: ContactListSortOrder;
  },
  filters?: Record<string, string[]>,
  searchRelated?: boolean,
  getCount?: boolean,
) => {
  const config: IContactSearchRequest = {
    url: '/contacts/search',
    params: {
      input,
      type: activeList,
      start: startIndex,
      sortBy: sort?.field,
      sortOrder: sort?.order,
      filters,
      limit,
      searchRelated,
      getCount,
    },
    method: 'get',
  };

  const { data } = await axios.request<IContactSearchResponse>(config);

  return data;
};

export default searchContacts;
